(() => {
  const DAY_MS = 24 * 60 * 60 * 1000;
  const INDIA_OFFSET_MS = 5.5 * 60 * 60 * 1000;

  function millisecondsUntilIndiaMidnight(timestamp) {
    const shiftedTimestamp = timestamp + INDIA_OFFSET_MS;
    const nextMidnight = (Math.floor(shiftedTimestamp / DAY_MS) + 1) * DAY_MS;
    return nextMidnight - shiftedTimestamp;
  }

  function splitCountdown(milliseconds) {
    const totalSeconds = Math.max(0, Math.floor(milliseconds / 1000));
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    return {
      hours: String(hours).padStart(2, '0'),
      minutes: String(minutes).padStart(2, '0'),
      seconds: String(seconds).padStart(2, '0'),
    };
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { millisecondsUntilIndiaMidnight, splitCountdown };
  }

  if (
    typeof window === 'undefined' ||
    typeof HTMLElement === 'undefined' ||
    typeof window.customElements === 'undefined'
  ) {
    return;
  }

  class FlashSaleCountdown extends HTMLElement {
    connectedCallback() {
      if (this.intervalId) return;

      this.hoursElement = this.querySelector('[data-countdown-hours]');
      this.minutesElement = this.querySelector('[data-countdown-minutes]');
      this.secondsElement = this.querySelector('[data-countdown-seconds]');
      this.update();
      this.intervalId = window.setInterval(() => this.update(), 1000);
    }

    disconnectedCallback() {
      if (!this.intervalId) return;

      window.clearInterval(this.intervalId);
      this.intervalId = null;
    }

    update() {
      const countdown = splitCountdown(millisecondsUntilIndiaMidnight(Date.now()));

      if (this.hoursElement) this.hoursElement.textContent = countdown.hours;
      if (this.minutesElement) this.minutesElement.textContent = countdown.minutes;
      if (this.secondsElement) this.secondsElement.textContent = countdown.seconds;

      this.setAttribute('data-ready', 'true');
      this.setAttribute(
        'aria-label',
        `Flash sale countdown: ${Number(countdown.hours)} hours, ${Number(countdown.minutes)} minutes, and ${Number(countdown.seconds)} seconds`
      );
    }
  }

  if (!window.customElements.get('flash-sale-countdown')) {
    window.customElements.define('flash-sale-countdown', FlashSaleCountdown);
  }
})();
